if (!customElements.get('tws-collection-options')) {
  class CollectionOptions extends HTMLElement {
    connectedCallback() {
      if (this.optionsConnected) return;
      this.optionsConnected = true;
      const root = this;
      const variants = JSON.parse(
        root.querySelector('[data-collection-variants]')?.textContent || '[]'
      );

      const selectors = Array.from(
        root.querySelectorAll('[data-collection-option]')
      );

      const variantInput = root.querySelector('[data-collection-variant-id]');
      const addButton = root.querySelector('[data-collection-add-button]');
      const addText = root.querySelector('[data-collection-add-text]');
      const status = root.querySelector('[data-collection-variant-status]');
      const cardWrapper = root.closest('.card-wrapper');
      const priceDisplay = cardWrapper?.querySelector('[data-card-price-display]');
      const originalPriceHtml = priceDisplay ? priceDisplay.innerHTML : '';

      const renderVariantPrice = (variant) => {
        if (!priceDisplay || !variant) return;

        if (variant.comparePrice) {
          priceDisplay.innerHTML = `
            <div class="price price--on-sale">
              <div class="price__container">
                <div class="price__sale">
                  <s class="price-item price-item--regular">${variant.comparePrice}</s>
                  <span class="price-item price-item--sale price-item--last">${variant.price}</span>
                </div>
              </div>
            </div>
          `;
        } else {
          priceDisplay.innerHTML = `
            <div class="price">
              <div class="price__container">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${variant.price}</span>
                </div>
              </div>
            </div>
          `;
        }
      };

      const restoreProductPrice = () => {
        if (priceDisplay) priceDisplay.innerHTML = originalPriceHtml;
      };

      const updateVariant = () => {
        const selectedOptions = selectors.map((select) => select.value);

        if (selectedOptions.some((value) => !value)) {
          variantInput.value = '';
          variantInput.disabled = true;
          addButton.disabled = true;
          addText.textContent = 'Choose options';
          status.textContent = '';
          restoreProductPrice();
          return;
        }

        const variant = variants.find((item) =>
          item.options.every(
            (option, index) => option === selectedOptions[index]
          )
        );

        if (!variant) {
          variantInput.value = '';
          variantInput.disabled = true;
          addButton.disabled = true;
          addText.textContent = 'Unavailable';
          status.textContent = 'That option combination is unavailable.';
          restoreProductPrice();
          return;
        }

        variantInput.value = variant.id;
        variantInput.disabled = false;
        renderVariantPrice(variant);

        if (variant.available) {
          addButton.disabled = false;
          addText.textContent = 'Add to cart';
          status.textContent = '';
        } else {
          addButton.disabled = true;
          addText.textContent = 'Sold out';
          status.textContent = 'This option is sold out.';
        }
      };

      selectors.forEach((select) => {
        select.addEventListener('change', updateVariant);
      });
      updateVariant();
    }
  }
  customElements.define('tws-collection-options', CollectionOptions);
}
